import { render, staticRenderFns } from "./ClaimPrint.vue?vue&type=template&id=7c45dcf7"
import script from "./ClaimPrint.vue?vue&type=script&lang=js"
export * from "./ClaimPrint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports